'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { Laboratory, SimilarLaboratoriesResponse } from '@medprev-web-app/api-graphql-client';
import { ReactNode } from 'react';

import { BranchLaboratoryAboutSection } from './branch-laboratory-about-section.component';
import { LaboratoryOthersLaboratories } from './laboratory-others-laboratories.component';

import { EntitySection } from '@/app/(main)/(pages)/_components/entities/entity-section.component';
import { EntitySectionDivider } from '@/app/(main)/(pages)/_components/entities/entity-section-divider.component';
import {
  EntityTab,
  EntityTabContent,
  EntityTabList,
  EntityTabProvider,
  EntityTabTrigger,
} from '@/app/(main)/(pages)/_components/entities/entity-tab.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface TabLaboratoryProps {
  laboratory: Laboratory;
  rating: ReactNode;
  initialSimilarLaboratories: SimilarLaboratoriesResponse | null;
}

export function TabLaboratory({
  laboratory,
  rating,
  initialSimilarLaboratories,
}: TabLaboratoryProps) {
  const hasSimilarLaboratories = (initialSimilarLaboratories?.total ?? 0) > 0;

  return (
    <EntityTabProvider>
      <EntityTab defaultValue="about" tabs={['about', 'rating', 'exams']}>
        <EntityTabList className="sticky top-0 bg-white pt-2 pb-4">
          <EntityTabTrigger
            value="about"
            data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_TAB_ABOUT}
          >
            Sobre
          </EntityTabTrigger>
          <EntityTabTrigger
            value="rating"
            data-analytics-event={AnalyticsEnum.LABORATORY_PROFILE_CLICK_TAB_REVIEWS}
          >
            Avaliações
          </EntityTabTrigger>
        </EntityTabList>

        <div>
          <EntityTabContent value="about">
            <BranchLaboratoryAboutSection laboratory={laboratory} />
          </EntityTabContent>

          <EntityTabContent value="rating">
            <EntitySectionDivider />
            {rating}
          </EntityTabContent>

          {initialSimilarLaboratories && hasSimilarLaboratories && (
            <EntityTabContent value="similar">
              <div>
                <hr />
                <EntitySection
                  data-testid={DataTestIdEnum.LABORATORY_PROFILE_SECTION_SIMILAR_LABORATORIES}
                  title="Outros postos de coleta"
                  id="similar-laboratories"
                  className="mb-3 md:mb-8"
                  titleStyles="mb-1"
                  removeHr
                >
                  <LaboratoryOthersLaboratories
                    laboratory={laboratory}
                    initialFetchResponse={initialSimilarLaboratories}
                  />
                </EntitySection>
              </div>
            </EntityTabContent>
          )}
        </div>
      </EntityTab>
    </EntityTabProvider>
  );
}
